import cloneDeep from 'lodash/cloneDeep';
import assign from 'lodash/assign';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import isEqual from 'lodash/isEqual';
/**
 * 注册配置信息管理
 */

var ConfigRegister = function () {
  function ConfigRegister() {
    this.components = new Map();
  }
  /**
   * 注册组件
   * @param config
   * @param additional 是否为覆盖追加
   */


  ConfigRegister.prototype.register = function (config, additional) {
    if (additional === void 0) {
      additional = false;
    }

    var name = config.name;
    var componentConfig;

    if (!name) {
      throw new Error("the config must include name");
    }

    if (additional) {
      if (!this.components.has(name)) {
        throw new Error("Component " + name + " is not registered.");
      }

      var existedConfig = this.components.get(name);
      componentConfig = Object.assign({}, existedConfig, config);
    } else {
      if (this.components.has(name)) {
        throw new Error("Component " + name + " is has registered.");
      }

      componentConfig = config;
    }

    this.components.set(name, componentConfig);
  };
  /**
   * 获取所有注册组件信息
   */


  ConfigRegister.prototype.getList = function () {
    return cloneDeep(this.components);
  };
  /**
   * 获取注册组件配置
   * @param name
   */


  ConfigRegister.prototype.get = function (name) {
    return this.components.get(name);
  };

  ConfigRegister.prototype.has = function (name) {
    return this.components.has(name);
  };

  return ConfigRegister;
}();
/**
 * 管理页面与编辑内容通讯
 */


var Emitter = function () {
  function Emitter(options) {
    var _this = this;

    this.listeners = {};

    this.handleMessage = function (event) {
      var verbose = _this.config.verbose;
      var data = event.data;

      if (!data) {
        return;
      }

      var type = data.type;
      var payload = data.payload;

      if (!type) {
        return;
      }

      if (verbose) {
        console.log('handle message', payload);
      }

      var callbacks = _this.listeners[type];

      if (callbacks && callbacks.length) {
        callbacks.forEach(function (call) {
          call(payload);
        });
      }
    };

    this.config = assign({
      origin: '*',
      isDebug: false
    }, options);
    window.addEventListener('message', this.handleMessage, false);
  }

  Emitter.prototype.setOptions = function (options) {
    var opts = assign({}, this.config, options);
    this.config = opts;
  };

  Emitter.prototype.on = function (type, callback) {
    if (this.listeners[type]) {
      this.listeners[type].push(callback);
    } else {
      this.listeners[type] = [callback];
    }
  };

  Emitter.prototype.emit = function (type, payload) {
    var _a = this.config,
        messageWindow = _a.messageWindow,
        origin = _a.origin,
        verbose = _a.verbose;
    var params = {
      type: type,
      payload: payload
    };
    messageWindow.postMessage(params, origin);

    if (verbose) {
      console.log('post message', {
        type: type,
        payload: payload
      });
    }
  };

  Emitter.prototype.destroy = function () {
    var messageWindow = this.config.messageWindow;
    messageWindow.removeEventListener('message', this.handleMessage);
  };

  return Emitter;
}();
/**
 * 聚合加载器管理
 *
 * 合并多个组件的数据加载，再通过入参 requestKey与结果 resultKey 中的值，把最终数据分拆给各个回调结果中
 */


var MixinLoader = function () {
  function MixinLoader() {
    this.items = {};
  }

  MixinLoader.prototype.register = function (options) {
    var name = options.name,
        loadData = options.loadData,
        requestKey = options.requestKey,
        resultKey = options.resultKey;
    var item = this.items[name];

    if (!item) {
      this.items[name] = {
        loadData: loadData,
        requestKey: requestKey,
        resultKey: resultKey,
        callbacks: []
      };
    }
  };

  MixinLoader.prototype.addCallback = function (name, params) {
    var item = this.items[name];

    if (!item) {
      return Promise.reject();
    }

    return new Promise(function (resolve, reject) {
      item.callbacks.push({
        resolve: resolve,
        reject: reject,
        args: params
      });
    });
  };

  MixinLoader.prototype.fire = function () {
    var _this = this;

    var items = this.items;
    forEach(items, function (item) {
      var callbacks = item.callbacks,
          loadData = item.loadData,
          requestKey = item.requestKey,
          resultKey = item.resultKey;
      var callArgs = [];
      forEach(callbacks, function (call) {
        callArgs.push(call.args);
      });

      var mixinArgs = _this.mixinArgs(callArgs, requestKey);

      loadData(mixinArgs).then(function (response) {
        var separateArgs;

        if (resultKey) {
          separateArgs = _this.separateArgs(callArgs, response, requestKey, resultKey);
        }

        forEach(callbacks, function (call, i) {
          if (resultKey) {
            call.resolve(separateArgs[i]);
          } else {
            call.resolve(response);
          }
        });
      }, function (response) {
        forEach(callbacks, function (call) {
          call.resolve(response);
        });
      });
    });
  };

  MixinLoader.prototype.mixinArgs = function (args, requestKey) {
    var mininResult = new Array();
    forEach(args, function (arg) {
      if (Object.prototype.toString.call(arg) === '[object Array]') {
        mininResult = mininResult.concat(arg);
      } else {
        mininResult.push(arg);
      }
    });

    if (requestKey) {
      mininResult = uniqBy(mininResult, requestKey);
    } else {
      mininResult = uniq(mininResult);
    }

    return mininResult;
  };

  MixinLoader.prototype.separateArgs = function (args, response, requestKey, resultKey) {
    var result = new Array(args.length);
    forEach(args, function (arg, index) {
      var requestKeys;

      if (requestKey) {
        requestKeys = map(arg, requestKey);
      } else {
        requestKeys = arg;
      }

      var matchedResponse = [];
      forEach(requestKeys, function (key) {
        forEach(response, function (item) {
          var resultKeyValue = get(item, resultKey);

          if (key === resultKeyValue) {
            matchedResponse.push(item);
          }
        });
      });
      result[index] = matchedResponse;
    });
    return result;
  };

  MixinLoader.prototype.clear = function () {
    this.items = {};
  };

  return MixinLoader;
}();

var Utils = {
  generateComponentId: function generateComponentId(name) {
    return name + '-' + parseInt(Math.random() * 1e8 + '').toString(16);
  }
};
var applicationComponent = new ConfigRegister();
var applicationConfigForm = new ConfigRegister();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
/**
 * 基础组件
 */


var BasicComponent = function () {
  function BasicComponent(name, id) {
    this.id = id;
    this.name = name;
  }

  return BasicComponent;
}();
/**
 * 页面渲染组件
 */


var Component = function (_super) {
  __extends(Component, _super);
  /**
   *
   * @param config 组件名，或者组件配置
   */


  function Component(config) {
    var _this = this;

    var name, id;
    var opts;

    if (typeof config === 'string') {
      name = config;
      id = Utils.generateComponentId(name);
    } else {
      var component = config.component,
          rest = __rest(config, ["component"]);

      if (!component) {
        throw new Error("the config must include component");
      }

      name = component;

      if (rest.componentId) {
        id = rest.componentId;
        delete rest.componentId;
      } else {
        id = Utils.generateComponentId(name);
      }

      opts = rest;
    }

    _this = _super.call(this, name, id) || this;

    _this.init(opts);

    return _this;
  }

  Component.prototype.init = function (config) {
    this.registerConfig = applicationComponent.get(this.name);

    if (!this.registerConfig) {
      this.isRegister = false;
      this.config = Object.assign({}, config);
    } else {
      this.isRegister = true;
      this.config = Object.assign({}, this.registerConfig.defaultConfig, config);
    }
  };

  Component.prototype.render = function (extra) {
    var render = this.registerConfig.render;
    return render(this.config, extra);
  };

  return Component;
}(BasicComponent);
/**
 * 组件配置表单
 */


var ConfigForm = function (_super) {
  __extends(ConfigForm, _super);

  function ConfigForm(componentProfile) {
    var _this = this;

    var component = componentProfile.component,
        id = componentProfile.id;

    if (!component) {
      throw new Error("the componentProfile must include name");
    }

    var registerConfig = applicationConfigForm.get(component);

    if (!registerConfig) {
      throw new Error("config form " + component + " is not registered.");
    }

    _this = _super.call(this, component, id) || this;
    _this.profile = componentProfile;
    _this.registerConfig = registerConfig;
    return _this;
  }

  ConfigForm.prototype.validate = function () {
    var config = this.getConfig();

    var id = config.id,
        component = config.component,
        onChange = config.onChange,
        rest = __rest(config, ["id", "component", "onChange"]);

    var validate = this.registerConfig.validate;
    return validate(rest);
  };

  ConfigForm.prototype.render = function (extra) {
    var config = this.getConfig();

    var id = config.id,
        component = config.component,
        onChange = config.onChange,
        rest = __rest(config, ["id", "component", "onChange"]);

    var render = this.registerConfig.render;
    return render({
      onChange: onChange,
      componentId: id,
      value: rest
    }, extra);
  };

  ConfigForm.prototype.getConfig = function () {
    return cloneDeep(this.profile);
  };

  return ConfigForm;
}(BasicComponent);
/**
 * 组件配置数据管理，构建组件实例集合和组件配置表单
 */


var ComponentManager = function () {
  function ComponentManager() {}
  /**
   *  根据组件配置信息生成组件实体集合
   * @param root
   * @param componentProfile 组件配置信息
   */


  ComponentManager.buildComponents = function (root, componentsProfile) {
    var components = new Array();

    if (!componentsProfile || root.items.length === 0) {
      return null;
    }

    forEach(root.items, function (item) {
      var componentProfile = componentsProfile[item.component];
      var componentId = item['component'];
      var component = new Component(_assign({
        componentId: componentId
      }, componentProfile));

      if (component.isRegister) {
        components.push(component);
      }
    });
    return components;
  };
  /**
   * 根据组件配置信息生成组件配置表单实例
   * @param componentProfile
   */


  ComponentManager.buildConfigForm = function (componentProfile) {
    var configForm = new ConfigForm(componentProfile);

    if (!componentProfile) {
      return null;
    }

    return configForm;
  };

  ComponentManager.add = function (profile, componentName, index) {
    var newProfile = cloneDeep(profile);
    var formConfig = applicationConfigForm.get(componentName);

    if (!formConfig) {
      throw new Error("Component " + componentName + " is not registered.");
    }

    var items = newProfile.root.items;
    var componentId = Utils.generateComponentId(componentName);
    items.splice(index, 0, {
      component: componentId
    });
    newProfile.components[componentId] = assign({
      component: componentName
    }, formConfig.defaultConfig);
    return newProfile;
  };

  ComponentManager.append = function (profile, componentName) {
    var nextIndex = profile.root.items.length;
    return ComponentManager.add(profile, componentName, nextIndex);
  };

  ComponentManager.remove = function (profile, index) {
    var newProfile = cloneDeep(profile);
    var componentId = newProfile.root.items[index].component;
    delete newProfile.components[componentId];
    newProfile.root.items.splice(index, 1);
    return newProfile;
  };

  ComponentManager.reorder = function (profile, from, to) {
    var newProfile = cloneDeep(profile);
    var c = newProfile.root.items;
    c.splice(to, 0, c.splice(from, 1)[0]);
    return newProfile;
  };

  ComponentManager.updateComponent = function (profile, index, componentProfile) {
    var newProfile = cloneDeep(profile);
    var componentId = newProfile.root.items[index].component;
    assign(newProfile.components[componentId], componentProfile);
    return newProfile;
  };

  ComponentManager.updateRoot = function (profile, rootConfig) {
    var newProfile = cloneDeep(profile);
    assign(newProfile.root, rootConfig);
    return newProfile;
  };

  return ComponentManager;
}();
/**
 * 页面管理 (后台管理页面配置表单使用)
 */


var PageManager = function () {
  function PageManager(profile) {
    this._events = {
      profileChange: null
    };
    this.profile = profile;
  }

  Object.defineProperty(PageManager.prototype, "profile", {
    get: function get() {
      return cloneDeep(this._profile);
    },
    set: function set(value) {
      if (isEqual(value, this._profile)) {
        return;
      }

      var events = this._events;
      this._profile = value;
      var copyProfile = cloneDeep(value);

      if (events && events.profileChange) {
        events.profileChange(copyProfile);
      }
    },
    enumerable: true,
    configurable: true
  });

  PageManager.prototype.addEventListener = function (eventName, callback) {
    this._events[eventName] = callback;
  };

  PageManager.prototype.getProfile = function () {
    return this.profile;
  };

  PageManager.prototype.saveProfile = function () {
    var profile = this.profile;
    return new Promise(function (resolve, reject) {
      if (profile) {
        resolve('');
      } else {
        reject('');
      }
    });
  };

  PageManager.prototype.getConfigForm = function (index) {
    var _this = this;

    var profile = this.profile;
    var componentId = profile.root.items[index].component;

    var componentProfile = _assign(_assign({
      id: componentId
    }, profile.components[componentId]), {
      onChange: function onChange(values) {
        _this.updateComponent(index, values);
      }
    });

    return ComponentManager.buildConfigForm(componentProfile);
  };

  PageManager.prototype.getRootConfigForm = function () {
    var _this = this;

    var profile = this.profile;

    var _a = profile.root,
        items = _a.items,
        rest = __rest(_a, ["items"]);

    var componentProfile = _assign(_assign({
      id: '0',
      component: 'root'
    }, rest), {
      onChange: function onChange(values) {
        _this.updateRoot(values);
      }
    });

    return ComponentManager.buildConfigForm(componentProfile);
  };

  PageManager.prototype.add = function (componentName, index) {
    this.profile = ComponentManager.add(this.profile, componentName, index);
  };

  PageManager.prototype.append = function (componentName) {
    this.profile = ComponentManager.append(this.profile, componentName);
  };

  PageManager.prototype.remove = function (index) {
    this.profile = ComponentManager.remove(this.profile, index);
  };

  PageManager.prototype.reorder = function (from, to) {
    this.profile = ComponentManager.reorder(this.profile, from, to);
  };

  PageManager.prototype.updateComponent = function (index, componentProfile) {
    this.profile = ComponentManager.updateComponent(this.profile, index, componentProfile);
  };

  PageManager.prototype.updateRoot = function (root) {
    this.profile = ComponentManager.updateRoot(this.profile, root);
  };

  PageManager.prototype.update = function (profile) {
    this.profile = cloneDeep(profile);
  };

  PageManager.prototype.validate = function (index) {
    var form = this.getConfigForm(index);
    return form.validate();
  };

  return PageManager;
}();
/**
 * 移动端页面渲染管理
 */


var PageRender = function () {
  function PageRender() {
    this.mixinLoader = new MixinLoader();
    this._events = {
      profileChange: null,
      rootChange: null,
      onRender: null
    };
    this.args = {};
  }

  PageRender.prototype.update = function (profile) {
    var _this = this;

    this.mixinLoader.clear();
    this._root = profile.root;
    var components = ComponentManager.buildComponents(this._root, profile.components);
    var events = this._events;
    var copyProfile = cloneDeep(profile);

    if (events && events.profileChange) {
      events.profileChange(copyProfile);
    }

    if (events && events.rootChange) {
      events.rootChange(copyProfile.root);
    }

    if (events && events.onRender) {
      var renders = [];

      if (components && components.length) {
        renders = components.map(function (i, index) {
          var registerConfig = i.registerConfig;
          var loader = registerConfig.loader;

          if (loader) {
            _this.mixinLoader.register({
              name: i.name,
              requestKey: loader.requestKey,
              resultKey: loader.resultKey,
              loadData: loader.loadData
            });
          }

          var loadData = null;

          if (loader || registerConfig.loadData) {
            loadData = function loadData(params) {
              if (loader) {
                return _this.mixinLoader.addCallback(i.name, params);
              } else {
                return registerConfig.loadData(params);
              }
            };
          }

          return {
            render: function render(extra) {
              return i.render(extra);
            },
            id: i.id,
            name: i.name,
            index: index,
            config: i.config,
            loadData: loadData,
            events: registerConfig.events
          };
        });
      }

      events.onRender(renders);
    }
  };

  PageRender.prototype.fireMixinLoad = function () {
    this.mixinLoader.fire();
  };

  PageRender.prototype.addEventListener = function (eventName, callback) {
    this._events[eventName] = callback;
  };

  return PageRender;
}();

export { applicationComponent as ApplicationComponent, applicationConfigForm as ApplicationConfigForm, Component, ComponentManager, Emitter, PageManager, PageRender };